// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XqCpm","comment":"styles_comment__2kp93"};